import api from './api';

export const addToCart = async (productId: number, quantity: number) => {
  const res = await api.post('/cart/add', { productId, quantity });
  return res.data;
};

export const getCart = async () => {
  const res = await api.get('/cart');
  return res.data;
};

export const updateCartItem = async (productId: number, quantity: number) => {
  const res = await api.put(`/cart/${productId}`, { quantity });
  return res.data;
};

export const removeCartItem = async (productId: number) => {
  const res = await api.delete(`/cart/${productId}`);
  return res.data;
};

export const clearCart = async () => {
  const res = await api.post(`/cart/clear`);
  return res.data;
};
